import React from "react";

/**
 * Site-wide launch banner. Shows on every public page above the first
 * fold. Auto-hides once Sat 22 Feb 2026 16:00 NZDT has passed.
 *
 * To remove permanently after launch, delete this component and unmount it
 * from `App.js`.
 */
export default function LaunchBanner() {
  // Next Saturday at 4pm NZ time (NZST = UTC+12, NZDT = UTC+13).
  // 4pm Sat 28 Jun 2026 NZST = 04:00 UTC Sat 28 Jun.
  const launchAt = new Date("2026-06-28T04:00:00Z");
  if (Date.now() > launchAt.getTime()) return null;

  return (
    <div
      data-testid="site-launch-banner"
      className="w-full text-center py-3 px-4 text-xs md:text-sm tracking-[0.18em] uppercase font-serif"
      style={{
        background: "linear-gradient(90deg, #3E1F46 0%, #6E1E3A 100%)",
        color: "#FBF6E9",
        borderBottom: "2px solid #C9A268",
      }}
      role="status"
      aria-live="polite"
    >
      ✦ We&apos;re refreshing everything &mdash; <strong>fresh launch this Saturday 28 June at 4pm.</strong>{" "}
      <span className="opacity-80 normal-case tracking-normal italic">
        Heritage HQ accounts are being rebuilt, you&apos;ll receive a new invite from us soon.
      </span>
    </div>
  );
}
